<template>
  <div id="app_header" class="flex w-full p-5 vs-card--header mb-5">
    <div class="w-full flex flex-col">
      <div class="w-full relative">
        <div class="flex w-full  justify-between items-center">
          <feather-icon
            v-if="buttonBack"
            icon="ArrowLeftIcon"
            class="mr-3 d-theme-dark-bg"
            @click.prevent="$router.back()"
          >
          </feather-icon>
          <div class="text-xl flex-1 flex flex-col ">
            <div class="font-semibold">{{ header.title }}</div>
            <div class="text-sm">{{ header.subtitle }}</div>
          </div>
          <div class="flex" v-if="actions">
            <div
              class="flex items-center cursor-pointer shadow px-4 py-2 rounded-lg mx-3"
              @click="toggleFilter(true)"
            >
              <feather-icon icon="FilterIcon" class="sm:mr-3"></feather-icon>
              <div class="hidden sm:block">Filter</div>
            </div>
            <div
              class="flex items-center cursor-pointer  shadow px-4 py-2 rounded-lg mx-3"
              @click="toggleSearch(true)"
            >
              <feather-icon icon="SearchIcon" class="sm:mr-3"></feather-icon>
              <div class="hidden sm:block">Cari</div>
            </div>
          </div>
          <div class="flex">
            <slot name="actions-custom"></slot>
          </div>
        </div>
        <transition name="slide">
          <HeaderSearch v-if="search.onSearch" />
        </transition>
      </div>
      <HeaderFilterPopup />
      <HeaderFilter v-if="filter.list.length > 0 && actions" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderSearch from "./HeaderSearch";
import HeaderFilter from "./HeaderFilter";
import HeaderFilterPopup from "./HeaderFilterPopup";

export default {
  components: {
    HeaderSearch,
    HeaderFilter,
    HeaderFilterPopup
  },
  props: {
    actions: {
      type: Boolean,
      default: true
    },
    buttonBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      header: state => state.globalApp.header,
      search: state => state.globalApp.search,
      filter: state => state.globalApp.filter
    })
  },
  methods: {
    toggleFilter(bol) {
      this.$store.dispatch("globalApp/toggleFilter", bol);
    },
    toggleSearch(bol) {
      this.$store.dispatch("globalApp/toggleSearch", bol);
    }
  }
};
</script>

<style lang="scss">
.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(200%, 0);
}
</style>
